import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { runProcessSimulation } from '../../Api/largeDataAnalyticsExternalApi';
import { selectLatestScenario } from '../../Store/slices/largeDataAnalytics.slice';
import ProcessConfigurator from './ProcessConfigurator';
import { GBMConfig, OUConfig, JDConfig } from '../../Configs/ScenarioEngine';
import {Row, Col, Card, Empty} from 'antd';
import MetaData from "./MetaData";
import ScenarioProbability from "./ScenarioProbability";
import SimulationPaths from "./SimulationPaths";

const ScenarioSimulation = () => {
  const dispatch = useDispatch();

  const handleSubmit = (processName, config, values) => {
    // Map the user-friendly parameter names to the backend parameter names
    const mappedParams = Object.entries(values).reduce((acc, [key, value]) => {
      const mappedKey = config.mapParams[key] || key;
      acc[mappedKey] = value;
      return acc;
    }, {});

    // Special handling for riskTolerance in GBM and JD models
    if (processName === 'gbm' || processName === 'jd') {
      mappedParams.sigma = mappedParams.sigma / 10; // Convert 1-10 scale to 0.1-1 scale
    }

    // Convert expectedReturn from percentage to decimal
    if ('mu' in mappedParams) {
      mappedParams.mu = mappedParams.mu / 100;
    }

    dispatch(runProcessSimulation({
      process_name: processName,
      processParams: mappedParams,
      T: 1,  // You can make these configurable if needed
      dt: 1/252,
    }));
  };

  const gbmResult = useSelector(state => selectLatestScenario(state, 'gbm'));
  const ouResult = useSelector(state => selectLatestScenario(state, 'ou'));
  const jdResult = useSelector(state => selectLatestScenario(state, 'jd'));

  return (
    <div>
      <ProcessConfigurator
        config={GBMConfig}
        onSubmit={(values) => handleSubmit('gbm', GBMConfig, values)}
      />
      {gbmResult && <ResultDisplay result={gbmResult} />}

      <ProcessConfigurator
        config={OUConfig}
        onSubmit={(values) => handleSubmit('ou', OUConfig, values)}
      />
      {ouResult && <ResultDisplay result={ouResult} />}

      <ProcessConfigurator
        config={JDConfig}
        onSubmit={(values) => handleSubmit('jd', JDConfig, values)}
      />
      {jdResult && <ResultDisplay result={jdResult} />}
    </div>
  );
};

const ResultDisplay = ({ result }) => {
  // Implement this component to display the simulation results
    if (!result)return null;
    console.log(result)

  return (
    <Row>
        <Col flex={'0 0 300px'}>
            <MetaData process={result.process} finalParams={result.final_params} config={result.config} />
            <ScenarioProbability analysis={result.analysis} />
        </Col>
        <Col flex={'1 1 800px'}>
            <SimulationPaths paths={result.sample_paths} title={result.process} />
        </Col>
    </Row>
  );
};

export default ScenarioSimulation;